import { PageName } from '@/enums/pageName'

export const WeightSuccessMessage = ({ pageName }: { pageName: string }) => {
  if (pageName === PageName.weightGoal) {
    return (
      <div className="weight-success-message">
        <div className="thanks">Great!</div>
        <div>We’ve excited to help you hit your goals.</div>
      </div>
    )
  }
  return (
    <div className="weight-success-message">
      <div className="thanks">Thank you for sharing!</div>
      <div>That’s important (and hard) first step!</div>
    </div>
  )
}
